module.exports = __webpack_public_path__ + "img/bg_text_cover.9fd80480.png";